import React from "react";
import { ReviewsFullBlock } from "tsi-common-react/src/components/ReviewsFullBlock/index";

import { templates } from "@reactivated";

// `starHasStroke` mirrors this site's ProductReviewsTemplate.tsx -- the island
// the legacy `{% react_product_reviews %}` tag mounted for this block.
export const Template = (
    props: templates.ReviewsFullBlockTemplate,
): React.JSX.Element => {
    return <ReviewsFullBlock value={props.value} starHasStroke={true} />;
};
